import React from "react";
import styled from "styled-components";

function WhiteBox({ children, backgroundColor = "white", style = {} }) {
  return (
    <Container backgroundColor={backgroundColor} style={style}>
      {children}
    </Container>
  );
}

const Container = styled.div`
  background-color: ${(props) => props.backgroundColor};
  border-radius: 6px;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
`;

export default WhiteBox;
